export { default } from './ModalCloseIcon';
